module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0674.64c70765.jpg";